import script from "./FundSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FundSection.vue?vue&type=script&setup=true&lang=js"

import "./FundSection.vue?vue&type=style&index=0&id=3823bb2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3823bb2c"]])

export default __exports__